export type PageItem = {
  id: number
  title: string
  link: string
}

export type MenuItem = {
  id: number
  text: string
  link: string
  target: '_self' | '_blank'
}

export const pages = [
  {
    id: 1,
    title: 'main',
    link: '/'
  },
  {
    id: 2,
    title: 'how-work',
    link: '/#services'
  },
  {
    id: 3,
    title: 'artists',
    link: '/#artists'
  },

  // {
  //   id: 4,
  //   title: 'sites',
  //   link: '/platforms'
  // },
  {
    id: 4,
    title: 'news',
    link: '/news'
  },

  //
  // {
  //   id: 6,
  //   title: 'reviews',
  //   link: '#reviews'
  // },
  {
    id: 5,
    title: 'partners',
    link: '#partners'
  }

  // {
  //   id: 8,
  //   title: 'faq',
  //   link: '/#faq'
  // }
] as PageItem[]

export const menuList = [
  {
    id: 1,
    text: 'cookie-policy',
    link: '/cookie-policy',
    target: '_blank'
  },
  {
    id: 2,
    text: 'privacy-policy',
    link: '/privacy-policy',
    target: '_blank'
  }
] as MenuItem[]
